import cx from 'classnames';
import React from 'react';
export const Button = ({ children, className, height, variant, width, ...rest }) => (React.createElement("button", { className: cx('tds-btn', {
        [`tds-btn--${height}`]: height,
        [`tds-btn--${variant}`]: variant,
        [`tds-btn--width-${width}`]: width,
    }, className), ...rest }, children));
